import MovieCard from "./MovieCard";
import "./MovieList.css";

export default function MovieList({ movies }) {
  if (movies.length === 0) {
    return (
      <div className="empty">
        <span className="empty__icon">🎬</span>
        <p className="empty__title">No titles found</p>
        <p className="empty__sub">
          Try adjusting your filters or add a new movie.
        </p>
      </div>
    );
  }

  return (
    <section>
      <p className="list-count">
        {movies.length} title{movies.length !== 1 ? "s" : ""}
      </p>
      <div className="movie-grid">
        {movies.map((movie, index) => (
          <div key={movie.id} style={{ animationDelay: `${index * 0.05}s` }}>
            <MovieCard movie={movie} />
          </div>
        ))}
      </div>
    </section>
  );
}
